var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as e from "react/jsx-runtime";
import * as t from "uitk-react-utils";
import * as r from "uitk-react-text";
import * as s from "uitk-react-sheet";
import * as i from "react";
import * as n from "uitk-react-icons";
import * as o from "uitk-react-button";
import * as a from "uitk-react-loader";
import * as c from "uitk-react-layout-position";
import * as l from "uitk-react-scrim";
var u = {
  d: (e, t) => {
    for (var r in t) u.o(t, r) && !u.o(e, r) && Object.defineProperty(e, r, {
      enumerable: !0,
      get: t[r]
    });
  },
  o: (e, t) => Object.prototype.hasOwnProperty.call(e, t)
};
(() => {
  var e;
  if ("string" == typeof import.meta.url && (e = import.meta.url), !e) throw new Error("Automatic publicPath is not supported in this browser");
  e = e.replace(/#.*$/, "").replace(/\?.*$/, "").replace(/\/[^\/]+$/, "/"), u.p = e;
})();
var d = {};
u.d(d, {
  td: () => x,
  A0: () => b,
  Y7: () => B
});
const p = (m = {
  Fragment: () => e.Fragment,
  jsx: () => e.jsx,
  jsxs: () => e.jsxs
}, h = {}, u.d(h, m), h);
var m, h;
const y = (e => {
    var t = {};
    return u.d(t, e), t;
  })({
    classNames: () => t.classNames
  }),
  k = (e => {
    var t = {};
    return u.d(t, e), t;
  })({
    UitkText: () => r.UitkText
  }),
  v = u.p + "./styles/egds-property-experience-search-highlight.css",
  f = y.classNames.bind(v),
  g = {
    HIGHLIGHT: "mark"
  },
  x = e => {
    const {
        inlineContentList: t,
        size: r,
        theme: s,
        weight: i
      } = e,
      n = f("uitk-text-highlight-color"),
      o = {
        theme: s,
        weight: i,
        size: r
      };
    return t && 0 !== (t === null || t === void 0 ? void 0 : t.length) ? (0, p.jsx)(p.Fragment, {
      children: t === null || t === void 0 ? void 0 : t.map((e, t) => {
        const {
            decorative: r,
            accessibility: s,
            text: i
          } = e,
          a = r && g[r],
          c = a ? (0, p.jsx)(a, {
            className: n,
            children: i
          }) : i;
        return (0, p.jsxs)(k.UitkText, Object.assign(Object.assign({
          inline: !0
        }, o), {
          children: [c, s && (0, p.jsx)("span", {
            className: "is-visually-hidden",
            children: s
          })]
        }), `inlineContent-item-${t}`);
      })
    }) : null;
  };
x.displayName = "SearchHighlight";
const S = (e => {
    var t = {};
    return u.d(t, e), t;
  })({
    UitkSheet: () => s.UitkSheet
  }),
  U = u.p + "./styles/egds-property-experience-sheet-centered-large.css",
  j = y.classNames.bind(U),
  b = e => {
    const {
        children: t,
        className: r,
        centeredSheetSize: s = "large"
      } = e,
      i = __rest(e, ["children", "className", "centeredSheetSize"]),
      n = j(r, `uitk-centered-sheet-${s}`);
    return (0, p.jsx)(S.UitkSheet, Object.assign(Object.assign({
      type: "centered",
      className: n
    }, i), {
      children: t
    }));
  };
b.displayName = "SheetCenteredLarge";
const N = (e => {
    var t = {};
    return u.d(t, e), t;
  })({
    useEffect: () => i.useEffect,
    useRef: () => i.useRef,
    useState: () => i.useState
  }),
  L = (e => {
    var t = {};
    return u.d(t, e), t;
  })({
    UitkIcon: () => n.UitkIcon
  }),
  w = (e => {
    var t = {};
    return u.d(t, e), t;
  })({
    UitkButtonSize: () => o.UitkButtonSize,
    UitkOverlayButton: () => o.UitkOverlayButton
  }),
  E = (e => {
    var t = {};
    return u.d(t, e), t;
  })({
    UitkLoader: () => a.UitkLoader
  }),
  I = (e => {
    var t = {};
    return u.d(t, e), t;
  })({
    UitkLayoutPosition: () => c.UitkLayoutPosition
  }),
  O = (e => {
    var t = {};
    return u.d(t, e), t;
  })({
    UitkScrim: () => l.UitkScrim,
    UitkScrimType: () => l.UitkScrimType
  }),
  P = u.p + "./styles/egds-property-experience-video-player.css",
  z = y.classNames.bind(P),
  B = e => {
    const {
        src: t,
        thumbnail: r,
        onError: s,
        captionSrc: i,
        showDefaultControls: n = !0,
        controlPosition: o = "bottomRight",
        autoplay: a = !1,
        muted: c = !1,
        autoplayInView: l = !1,
        threshold: u = .5,
        controlButtonSize: d = w.UitkButtonSize.MEDIUM,
        playsInline: m = !0,
        showLoader: h = !1,
        showScrim: y = !1
      } = e,
      k = __rest(e, ["src", "thumbnail", "onError", "captionSrc", "showDefaultControls", "controlPosition", "autoplay", "muted", "autoplayInView", "threshold", "controlButtonSize", "playsInline", "showLoader", "showScrim"]),
      [v, f] = (0, N.useState)(!0),
      [g, x] = (0, N.useState)(!1),
      [S, U] = (0, N.useState)(!0),
      j = z("egds-team-video-player"),
      b = (0, N.useRef)(null),
      P = ((e, {
        threshold: t = 0,
        root: r = null,
        rootMargin: s = "0%",
        freezeOnceVisible: i = !1
      }) => {
        const [n, o] = (0, N.useState)(),
          a = (n === null || n === void 0 ? void 0 : n.isIntersecting) && i,
          c = ([e]) => {
            o(e);
          };
        return (0, N.useEffect)(() => {
          const i = e === null || e === void 0 ? void 0 : e.current;
          if (!window.IntersectionObserver || a || !i) return;
          const n = new IntersectionObserver(c, {
            threshold: t,
            root: r,
            rootMargin: s
          });
          return n.observe(i), () => n.disconnect();
        }, [e === null || e === void 0 ? void 0 : e.current, JSON.stringify(t), r, s, a]), n;
      })(b, {
        threshold: u
      }),
      B = () => {
        const e = b.current;
        if (!e || g) return;
        x(!0);
        const t = e.play();
        void 0 !== t && t.then(e => e).catch(e => e);
      },
      T = () => {
        const e = b.current;
        e && g && (e.pause(), x(!1));
      };
    return (0, N.useEffect)(() => {
      const e = b.current;
      if (!e) return;
      const t = () => x(!0),
        r = () => x(!1);
      return e.addEventListener("play", t), e.addEventListener("pause", r), () => {
        e.removeEventListener("play", t), e.removeEventListener("pause", r);
      };
    }, []), (0, N.useEffect)(() => {
      b.current && a && !l && B();
    }, [a, l]), (0, N.useEffect)(() => {
      if (b.current && P && l) return P.isIntersecting && !g && B(), () => {
        P.isIntersecting && l && T();
      };
    }, [P, l]), (0, p.jsxs)("div", {
      className: "video-player-box",
      children: [y && S && (0, p.jsx)(O.UitkScrim, {
        type: O.UitkScrimType.OVERLAY
      }), h && S && (0, p.jsx)(I.UitkLayoutPosition, {
        className: "video-player-loader",
        type: "absolute",
        position: {
          top: "center",
          left: "center"
        },
        children: (0, p.jsx)(E.UitkLoader, {
          isDarkBackground: !0
        })
      }), (0, p.jsxs)("video", Object.assign(Object.assign({
        ref: b,
        poster: r,
        controls: n,
        style: {
          width: "100%"
        },
        onError: e => {
          f(!1), U(!1), s && s(e);
        },
        onLoadedData: () => {
          U(!1);
        },
        className: j,
        autoPlay: a && !l,
        muted: a || c,
        playsInline: m
      }, k), {
        children: [(0, p.jsx)("source", {
          src: t,
          type: "video/mp4"
        }), (0, p.jsx)("track", {
          src: i !== null && i !== void 0 ? i : "caption",
          kind: "captions"
        })]
      })), !n && v && (0, p.jsx)("div", {
        className: `video-player-controls-${o}`,
        children: (0, p.jsx)(w.UitkOverlayButton, {
          onClick: () => {
            const e = b.current;
            e && (e.paused ? B() : T());
          },
          size: d,
          children: (0, p.jsx)(L.UitkIcon, {
            className: "video-player-controls-icon",
            name: g ? "pause" : "play_arrow"
          })
        })
      })]
    });
  };
B.displayName = "VideoPlayer";
var T = d.td,
  C = d.A0,
  $ = d.Y7;
export { T as SearchHighlight, C as SheetCenteredLarge, $ as VideoPlayer };